import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { Button } from "shared/buttons"

const AddFacilityGroupCodeButton = ({ onClick }) => {
  const { name: facilityName } = useCustomName(FACILITY_KEY)

  return (
    <Button
      className="border border-light-300 text-focus"
      text={`+ Add ${facilityName} Group Code`}
      onClick={onClick}
    />
  )
}

AddFacilityGroupCodeButton.propTypes = {
  onClick: types.func.isRequired,
}

export default AddFacilityGroupCodeButton
